import { createContext } from "react";
import { createEditCoverGalleryStore } from "../stores/editCoverGalleryStore";

export interface EditCoverGalleryContextType {
	store: ReturnType<typeof createEditCoverGalleryStore>;
}

const EditCoverGalleryContext = createContext<EditCoverGalleryContextType | null>(null);
export default EditCoverGalleryContext;
